import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20dramatic%20lighting%2C%20red%20velvet%20curtains%2C%20film%20projector%20beam%2C%20golden%20and%20amber%20tones%2C%20elegant%20composition%2C%20professional%20film%20photography%2C%20dark%20rich%20atmosphere%2C%20sophisticated%20cinema%20aesthetic&width=1920&height=1080&seq=hero-bg-91pian&orientation=landscape"
          alt="91片视频平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs md:text-sm font-medium border border-primary-500/30 mb-6 whitespace-nowrap">
          正版高清资源 · 极速播放体验
        </span>
        <h1 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-white max-w-3xl leading-tight">
          91片正版资源
          <br />
         一站直达
        </h1>
        <p className="mt-5 text-sm md:text-base text-white/70 max-w-xl leading-relaxed">
          国内领先的视频内容平台，海量高清资源触手可及。
          无论您搜索什么类型的内容，这里都能满足您的观影需求。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/dongzuo"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8 md:gap-16 mt-14">
          <div className="text-center">
            <p className="font-heading font-bold text-2xl md:text-3xl text-white">5000万+</p>
            <p className="text-xs md:text-sm text-white/50 mt-1">注册用户</p>
          </div>
          <div className="text-center">
            <p className="font-heading font-bold text-2xl md:text-3xl text-white">20万+</p>
            <p className="text-xs md:text-sm text-white/50 mt-1">正版内容</p>
          </div>
          <div className="text-center">
            <p className="font-heading font-bold text-2xl md:text-3xl text-white">800万</p>
            <p className="text-xs md:text-sm text-white/50 mt-1">日活跃用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}